import styles from './Header.module.scss'
import React from 'react'
import useMenu from '@/utils/hooks/useMenu'
import Link from 'next/link'
import logo from '@/assets/images/logo.png'
import Image from 'next/image'
import { useGetCustomerQuery } from '@/api/customer'
import { useTranslation } from 'next-i18next'
import CartWidget from '@/components/cart/CartWidget/CartWidget'
import useLocalizedPath from '@/utils/hooks/useLocalizedPath'
import MenuDropdown from './MenuDropdown/MenuDropdown'
import AccountDropdown from './AccountDropdown/AccountDropdown'

type Props = {}

const Header = (props: Props) => {
  const menuItems = useMenu()
  const { data: customer } = useGetCustomerQuery()
  const { t } = useTranslation('common')
  const getLocalizedPath = useLocalizedPath()
  const isLoggedIn = !!customer?.id

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <header>
          <Link href="/"><Image src={logo} width={264} alt="Statusfälgar" /></Link>
        </header>
        <nav>
          <ol className={isLoggedIn ? styles.withAccount : undefined}>
            {menuItems.map((item) => (
              <MenuDropdown key={item.url} item={item} />
            ))}
            {isLoggedIn ? (
              <AccountDropdown />
            ) : (
              <li>
                <Link href={getLocalizedPath('login')}>{t('menu.login')}</Link>
              </li>
            )}
            <CartWidget />
          </ol>
        </nav>
      </div>
    </div>
  )
}

export default Header